import type { KeyPersonsListParams } from './types';

export const keyPersonsKeys = {
  all: ['key-persons'] as const,
  lists: () => [...keyPersonsKeys.all, 'list'] as const,
  list: (params: KeyPersonsListParams) =>
    [...keyPersonsKeys.lists(), params] as const,
  /** Prefix matching every per-entity list; invalidate this to refresh all of them. */
  forEntities: () => [...keyPersonsKeys.all, 'for-entity'] as const,
  forEntity: (corporationId: number) =>
    [...keyPersonsKeys.all, 'for-entity', corporationId] as const,
  deletePreview: (id: number) =>
    [...keyPersonsKeys.all, 'delete-preview', id] as const,
  detail: (id: number) => [...keyPersonsKeys.all, 'detail', id] as const,
  roleAssignments: (id: number) =>
    [...keyPersonsKeys.all, 'role-assignments', id] as const,
  roleEligibleEntities: (id: number) =>
    [...keyPersonsKeys.all, 'role-eligible-entities', id] as const,
  identityDocuments: (id: number, country: string) =>
    [...keyPersonsKeys.all, 'identity-documents', id, country] as const,
  attributeProperties: (companyId: number) =>
    [...keyPersonsKeys.all, 'attribute-properties', companyId] as const,
} as const;
